export default __webpack_public_path__ + "static/media/pk.cd585ae0.svg";